import {
    LoadingManager,
    TextureLoader,
    sRGBEncoding,
    LinearEncoding,
    WebGLRenderer,
    MeshBasicMaterial,
    MeshStandardMaterial,
    MeshPhysicalMaterial,
    Color,
    DoubleSide,
    RepeatWrapping
} from "three";

import { defPath } from "../config/defPath";

import { isM } from "./alpha"


// ---------------------------------------------------------------------------

const maxAnisotropy = new WebGLRenderer().capabilities.getMaxAnisotropy()

const manager = new LoadingManager()
const textureLoader = new TextureLoader(manager)

export let texturesData = {
    loaded: 0,
    total: 0,
    managerState: 'Pending',
    size: {
        raw: [ ],
        total: 0,
        percent: 0
    },
}

manager.onStart = (url, itemsLoaded, itemsTotal) => {
    // console.log( 'Started loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
    texturesData.managerState = 'Loading'
}
manager.onProgress = (url, itemsLoaded, itemsTotal ) => {
    // console.log( 'Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
    texturesData.loaded = itemsLoaded
    texturesData.total = itemsTotal
}
manager.onLoad = ( ) => {
    texturesData.managerState = 'Ready'
    // console.log(`Textures: ${texturesData.total}, ${(texturesData.size.total / 1024 / 1024).toFixed(2)}Mb`)
}

export function imagesLoader(tx_name, encoding='sRGB') {
    
    let path = `${defPath}/assets/glb/textures/`
    // if(isM) path = './assets/glb/textures/min/'

    const t = textureLoader.load(`${path}${tx_name}`, 
        (img) => {
            // console.log(tx_name)
        }, 
        (xhr) => {
            // if(!texturesData.size.raw.includes( xhr.total )) texturesData.size.raw.push( xhr.total )
        },
        (error) => { console.error(`[ERROR] Image '${tx_name}'`) }
    )

    t.encoding = encoding === 'sRGB' ? sRGBEncoding : LinearEncoding
    t.flipY = false
    t.anisotropy = maxAnisotropy
    // t.dispose()

    return t
}

export function imagesLoaderPromise(textureName, encoding='sRGB') {
    return new Promise(resolve => {
        
        let path = `${defPath}/assets/glb/textures/`
        // if(isM) path = './assets/glb/textures/min/'

        textureLoader.load(`${path}${textureName}`, 
            (img) => {
                img.encoding = encoding === 'sRGB' ? sRGBEncoding : LinearEncoding
                img.flipY = false
                // console.log(tx_name)
                resolve(img)
            }, 
            (xhr) => {
                // if(!texturesData.size.raw.includes( xhr.total )) texturesData.size.raw.push( xhr.total )
            },
            (error) => { console.error(`[ERROR] Image '${textureName}'`) }
        )
    })
}


// ---------------------------------------------------------------------------


        // Obsolote debido a que el TextureLoader
        // ya no recibe valores de carga parcial y total
        // esperar fix


    // function loadControl() {
    //     // texturesData.size.total = 0
    //     // for (var y = 0; y < texturesData.size.raw.length; y++){
    //     //     texturesData.size.total += texturesData.size.raw[y]
    //     // }

    //     texturesData.size.percent = Math.round( (texturesData.loaded / texturesData.total) * 100)
    //     if( isNaN(texturesData.size.percent) ) texturesData.size.percent = 0

    //     if(texturesData.size.percent === 100) {
    //         texturesData.loadFinish = true
    //     }
    // }
    // let r
    // function anim() {
    //     r = requestAnimationFrame( anim )
    //     if(texturesData.loadFinish == false) {
    //         loadControl()
    //     } else {
    //         window.cancelAnimationFrame( r )
    //     }
    // }
    // anim()


// ----------------------------------------------------------------------------
// Materials ------------------------------------------------------------------

// export const shadow_mat = new THREE.MeshBasicMaterial({
//     transparent: true,    // so we can see the ground
//     depthWrite: false,    // so we don't have to sort
//     opacity: 0.5,
//     side: THREE.DoubleSide
// })
// shadow_mat.map = imagesLoader('shadow_min.png')

// export const dummy_mat = new MeshStandardMaterial({
//     map: imagesLoader('dummy.png')
// })
// dummy_mat.map.wrapS = dummy_mat.map.wrapT = RepeatWrapping
// dummy_mat.map.repeat.set(10,10)

//

export const botella_mat = new MeshPhysicalMaterial({
    color: new Color(0x9f5008).convertSRGBToLinear(),
    metalness: 0,
    roughness: 0.15,
    envMapIntensity: 1.15,
    transmission: 0.95,
    clearcoat: 0.5,
    clearcoatRoughness: 0.3,
    specularColor: new Color(0xffb802).convertSRGBToLinear(),
    thickness: 40,
})
export const tapa_mat = new MeshStandardMaterial({
    color: new Color(0xffe700).convertSRGBToLinear(),
    metalness: 0.9,
    roughness: 0.3,
    side: DoubleSide,
})
export const etiqueta_mat = new MeshStandardMaterial({
    metalness: 0.75,
    roughness: 0.35,
    map: imagesLoader('Etiqueta.png'),
    transparent: true,
    alphaMap: imagesLoader('Etiqueta_alpha.png'),
})

export const glass_mat = new MeshPhysicalMaterial({
    // transparent: true,
    color: new Color(0xb9e9ff).convertSRGBToLinear(),
    roughness: 0.15,
    metalness: 0,
    transmission: 0.95,
    // thickness: 0.15,
})

//

export const lata_mat = new MeshStandardMaterial({
    map: imagesLoader('v3_Lata.jpg'),
    metalness: 0.85,
    roughness: 0.4,
    envMapIntensity: 0.85,
})

//

export const pub_mat = new MeshStandardMaterial({
    map: imagesLoader('v3_Pub_lucho.jpg'),
    metalness: 0.33,
    roughness: 0.95,
})